<template>
  <div class="head df align_center justify_between pt5 pb5">
    <div class="head-logo pl20 df align_center">
      <router-link to="/">
        <img src="../assets/images/logo.png" alt="logo">
      </router-link>
      <div class="df flex_column index-weather" style="margin-left: 25px;" v-if="weather && !isNaN(temperature)">
        <div class="f13 op90">今日景区天气</div>
        <div class="df align_center f17 b mt5">
          <!-- <img src="../assets/images/weather-icon1.png" width="30" class="mr10" alt=""> -->
          <img :src="path" width="30" class="mr10" alt="">
          <div class="mr10">{{this.weather }}</div>
          <div class="mr10">{{this.temperature}}℃</div>
        </div>
      </div>
    </div>
    <div class="nav-item df f1 justify_end align_center pr20">
      <div class="nav-box rel" :class="!activeIndex || activeIndex == 0 ? 'active' : ''">
        <router-link to="/" class="df align_center flex_column align_center justify_center nav-link">
          <strong class="f18 b">首页</strong>
          <em class="f12 n">Home</em>
        </router-link>
      </div>
      <div class="nav-box rel" :class="activeIndex == 1 ? 'active' : ''">
        <router-link to="/pages/yinxiang/index" class="df align_center flex_column align_center justify_center nav-link">
          <strong class="f18 b">印象富林</strong>
          <em class="f12 n">Impressions Guangfulin</em>
        </router-link>
        <div class="nav-box-sub abs bgwh box-border">
          <div class="db nav-sub-link">
            <router-link to="/pages/yinxiang/index" class="f16">富林印迹</router-link>
          </div>
          <div class="db nav-sub-link">
            <router-link to="/pages/yinxiang/spot" class="f16">富林景点</router-link>
          </div>
          <div class="db nav-sub-link">
            <a href="https://pano.gflpark.com/pano/?module=pano" target="_blank" class="f16">全景导览</a>
          </div>
        </div>
      </div>
      <div class="nav-box rel" :class="activeIndex == 2 ? 'active' : ''">
        <router-link to="/pages/wanzhuan/index" class="df align_center flex_column align_center justify_center nav-link">
          <strong class="f18 b">玩转富林</strong>
          <em class="f12 n">Explore Guangfulin</em>
        </router-link>
        <div class="nav-box-sub abs bgwh box-border">
          <div class="db nav-sub-link">
            <router-link to="/pages/wanzhuan/index" class="f16">入园指南</router-link>
          </div>
          <div class="db nav-sub-link">
            <router-link to="/pages/wanzhuan/jiaotong" class="f16">交通指南</router-link>
          </div>
          <div class="db nav-sub-link">
            <router-link to="/pages/wanzhuan/gonglue" class="f16">游记攻略</router-link>
          </div>
          <div class="db nav-sub-link">
            <router-link to="/pages/wanzhuan/yanyi" class="f16">精彩演绎</router-link>
          </div>
          <div class="db nav-sub-link">
            <router-link to="/pages/wanzhuan/jinianpin" class="f16">纪念品展示</router-link>
          </div>
        </div>
      </div>
      <div class="nav-box rel" :class="activeIndex == 3 ? 'active' : ''">
        <router-link to="/pages/zixun/zixun-company" class="df align_center flex_column align_center justify_center nav-link">
          <strong class="f18 b">景区资讯</strong>
          <em class="f12 n">News</em>
        </router-link>
        <div class="nav-box-sub abs bgwh box-border">
          <!-- <div class="db nav-sub-link">
            <router-link to="/zixun" class="f16">富林活动</router-link>
          </div> -->
          <!-- <div class="db nav-sub-link">
            <router-link to="/pages/zixun/zixun-announcement" class="f16">公告信息</router-link>
          </div> -->
          <div class="db nav-sub-link">
            <router-link to="/pages/zixun/zixun-company" class="f16">景区资讯</router-link>
          </div>
        </div>
      </div>
      <div class="nav-box rel" :class="activeIndex == 4 ? 'active' : ''">
        <router-link to="/pages/yuding/index" class="df align_center flex_column align_center justify_center nav-link">
          <strong class="f18 b">预订服务</strong>
          <em class="f12 n">Reservation Services</em>
        </router-link>
        <div class="nav-box-sub abs bgwh box-border">
          <div class="db nav-sub-link">
            <router-link to="/pages/yuding/index" class="f16">在线购票</router-link>
          </div>
          <div v-if="dynamicLinkData && dynamicLinkData.Items && dynamicLinkData.Items.length > 0">
            <div class="db nav-sub-link" v-for="(item, index) in dynamicLinkData.Items" :key="index">
              <a :href="item.ThirdLink.Path" target="_blank">{{ item.Name }}</a>
            </div>
          </div>
          <div class="db nav-sub-link">
            <router-link to="/pages/yuding/food" class="f16">美食餐饮</router-link>
          </div>
          <div class="db nav-sub-link">
            <router-link to="/pages/yuding/hotel" class="f16">客房住宿</router-link>
          </div>
          <div class="db nav-sub-link">
            <router-link to="/pages/yuding/leisure" class="f16">休闲娱乐</router-link>
          </div>
          <div class="db nav-sub-link">
            <router-link to="/pages/yuding/vip" class="f16">贵宾服务</router-link>
          </div>
          <div class="db nav-sub-link">
            <router-link to="/pages/yuding/club" class="f16">会务服务</router-link>
          </div>
        </div>
      </div>
      <div class="nav-box rel" :class="activeIndex == 5 ? 'active' : ''">
        <router-link to="/pages/lianxi/index" class="df align_center flex_column align_center justify_center nav-link">
          <strong class="f18 b">联系我们</strong>
          <em class="f12 n">Contact Us</em>
        </router-link>
        <div class="nav-box-sub abs bgwh box-border">
          <div class="db nav-sub-link">
            <router-link to="/pages/lianxi/index" class="f16">联系方式</router-link>
          </div>
          <div class="db nav-sub-link">
            <router-link to="/pages/lianxi/lianxi-team" class="f16">团队、企业合作</router-link>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import weather from "@/services/client/cont/weather";
import promotionService from '@/services/client/cont/promotion'
export default {
  name: "app",
  props: ["activeIndex"],
  data() {
    return {
      weather: null,
      temperature: null,
      path: null,
      action2: null,
      dynamicLinkCode: 'app-ydfw-dynamic-link',
      dynamicLinkData: null,
    };
  },
  mounted() {
    this.getlatestweather();
    this.lopexecute();
    this.loadDynamicLink();
  },
  beforeDestroy() {
    clearInterval(this.action2);
  },
  methods: {
    lopexecute() {
      this.action2 = setInterval(() => {
        this.getlatestweather();
      }, 1000 * 60 * 60 * 6);
    },
    getlatestweather() {
      this.$nextTick(() => {
        weather.getDay("松江区").then((res) => {
          if (res.Code == 200 && res.Data) {
            this.weather = res.Data.Items[0].Weather;

            if (
              this.weather.includes("阴") == true ||
              this.weather.includes("多云") == true
            ) {
              this.path = require("@/assets/images/weather-icon1.png");
            } else if (this.weather.includes("晴") == true) {
              this.path = require("@/assets/images/sun.jpeg");
            } else if (this.weather.includes("雨") == true) {
              this.path = require("@/assets/images/rain.jpeg");
            } else if (this.weather.includes("电") == true) {
              this.path = require("@/assets/images/thunder.jpeg");
            } else if (this.weather.includes("雾") == true) {
              this.path = require("@/assets/images/fog.jpeg");
            } else if (this.weather.includes("雪") == true) {
              this.path = require("@/assets/images/snow.jpeg");
            }
            this.temperature = res.Data.Items[0].Temperature;
          }
        });
      });
    },
    loadDynamicLink(){
      promotionService.detail(this.dynamicLinkCode).then(res => {
        if(res.Code == 200) {
          this.dynamicLinkData = res.Data;
        }
      })
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/header.vue